/**
 * Leader EA Email Constants
 *
 * TODO: Migrate this data to a database solution for better maintainability and scalability.
 * Currently as of Oct 2025, there is no service that provides this information, these are stored in wiki pages.
 * https://w.amazon.com/bin/view/Business%26CorporateDevelopment/Admin/SVPMeetings/
 * This approach is acceptable short-term as leader EA assignments change infrequently.
 */

export interface LeaderEAEmail {
  leader: string;
  alias: string;
  eaEmailAddress: string | null;
}

export const LEADER_EA_EMAIL_DATA: LeaderEAEmail[] = [
  {
    leader: 'Andy Jassy',
    alias: 'ajassy',
    eaEmailAddress: 'aj-ea@amazon.com'
  },
  {
    leader: 'Amit Agarwal',
    alias: 'amit',
    eaEmailAddress: 'amit-ea@amazon.com'
  },
  {
    leader: 'Beth Galetti',
    alias: 'galettib',
    eaEmailAddress: 'galetti-office@amazon.com'
  },
  {
    leader: 'Bob Carrigan',
    alias: 'carrigan',
    eaEmailAddress: null
  },
  {
    leader: 'Brian Olsavsky',
    alias: 'olsavsky',
    eaEmailAddress: 'cfo-assist@amazon.com'
  },
  {
    leader: 'Christine Beauchamp',
    alias: 'cmbeau',
    eaEmailAddress: 'beauchamp-ea@amazon.com'
  },
  {
    leader: 'Colleen Aubrey',
    alias: 'caubrey',
    eaEmailAddress: 'caubrey-ea@amazon.com'
  },
  {
    leader: 'Dave Treadwell',
    alias: 'tread',
    eaEmailAddress: 'tread-ea@amazon.com'
  },
  {
    leader: 'David Zapolsky',
    alias: 'davidz',
    eaEmailAddress: null
  },
  {
    leader: 'Doug Herrington',
    alias: 'dherring',
    eaEmailAddress: 'doug-ea@amazon.com'
  },
  {
    leader: 'Drew Herdener',
    alias: 'herdener',
    eaEmailAddress: 'herdener-ea@amazon.com'
  },
  {
    leader: 'Hudson Thrift',
    alias: 'thrift',
    eaEmailAddress: 'hudson-support@amazon.com'
  },
  {
    leader: 'James Hamilton',
    alias: 'james',
    eaEmailAddress: 'budebbie@amazon.com'
  },
  {
    leader: 'John Felton',
    alias: 'johnfelt',
    eaEmailAddress: 'felton-ea@amazon.com'
  },
  {
    leader: 'Matt Garman',
    alias: 'garman',
    eaEmailAddress: 'garman-executive-office@amazon.com'
  },
  {
    leader: 'Mike Hopkins',
    alias: 'mikehopk',
    eaEmailAddress: null
  },
  {
    leader: 'Neil Lindsay',
    alias: 'nlindsay',
    eaEmailAddress: 'lindsay-ea@amazon.com'
  },
  {
    leader: 'Panos Panay',
    alias: 'panosp',
    eaEmailAddress: 'panos-ea@amazon.com'
  },
  {
    leader: 'Paul Kotas',
    alias: 'kotas',
    eaEmailAddress: 'georgire@amazon.com'
  },
  {
    leader: 'Peter DeSantis',
    alias: 'desantis',
    eaEmailAddress: 'tnaes-team@amazon.com'
  },
  {
    leader: 'Peter Krawiec',
    alias: 'krawiec',
    eaEmailAddress: 'krawiec-ea-team@amazon.com'
  },
  {
    leader: 'Rohit Prasad',
    alias: 'roprasad',
    eaEmailAddress: 'roprasad-ea@amazon.com'
  },
  {
    leader: 'Russell Grandinetti',
    alias: 'russ',
    eaEmailAddress: 'russ-ea@amazon.com'
  },
  {
    leader: 'Steve Boom',
    alias: 'sboom',
    eaEmailAddress: null
  },
  {
    leader: 'Steve Schmidt',
    alias: 'steve',
    eaEmailAddress: 'cso-support@amazon.com'
  },
  {
    leader: 'Udit Madan',
    alias: 'uditm',
    eaEmailAddress: 'udit-ea@amazon.com'
  },
  {
    leader: 'Tobias Straub',
    alias: 'tobias',
    eaEmailAddress: 'tobias-ea@amazon.com'
  },
  {
    leader: 'David Brown',
    alias: 'dbrown',
    eaEmailAddress: 'dbrown-support@amazon.com'
  },
  {
    leader: 'Deepak Singh',
    alias: 'deesingh',
    eaEmailAddress: 'deesingh-support-team@amazon.com'
  },
  {
    leader: 'Dharmesh Mehta',
    alias: 'dharmesm',
    eaEmailAddress: 'dharmesh-ea@amazon.com'
  },
  {
    leader: 'Prasad Kalyanaraman',
    alias: 'kprasad',
    eaEmailAddress: 'tamabav-team@amazon.com'
  },
  {
    leader: 'Swami Sivasubramanian',
    alias: 'swami',
    eaEmailAddress: 'swami-support@amazon.com'
  },
  {
    leader: 'Tim Halladay',
    alias: 'timhall',
    eaEmailAddress: 'halladay-ea@amazon.com'
  },
  {
    leader: 'Vasi Philomin',
    alias: 'vasi',
    eaEmailAddress: 'vasi-support@amazon.com'
  }
];
